import { Component, Renderer2, ElementRef } from '@angular/core';
import { applyFroalaAriaFix, stripFroalaWatermark } from '../../common/utils/froala.utils';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { LawService } from '../services/law.service';
import { NavService } from '../services/nav.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { Law } from '../models/models';

@Component({
    selector: 'law-library-editor',
    templateUrl: './law-library-editor.component.html',
    styleUrls: ['./law-library-editor.component.scss'],
    standalone: false
})
export class LawLibraryEditorComponent {
    public _law: Law;
    public currentlyEditingLawName: any;

    private _editorOptions: any = null;
    get editorOptions() : Object {
        if (!this._editorOptions) {
            let conf = window["PdfConfig"] as any;
            let key = (conf != null) ? conf.editorLicenseKey : "";
            this._editorOptions = applyFroalaAriaFix({
                placeholderText: 'Type Something',
                key: key
            });
        }
        return this._editorOptions;
    };

    form: FormGroup = new FormGroup({
        name: new FormControl(null, [Validators.required]),
        ORC: new FormControl(null, [Validators.required]),
        content: new FormControl(null, [Validators.required]),
        url: new FormControl({ value: null, disabled: true }),
        directurl: new FormControl({ value: null, disabled: true }),
        updatedBy: new FormControl({ value: null, disabled: true }),
        updatedDate: new FormControl({ value: null, disabled: true }),
    });

    constructor(
        public _lawService: LawService,
        public _router: Router,
        public _renderer: Renderer2,
        public _elementRef: ElementRef,
        public _activatedRoute: ActivatedRoute,
        public _navService: NavService
    ) {
        _activatedRoute.data.subscribe((result) => {
            if (result.law) {
                this._law = result.law;
                this._assignForm();
                this.currentlyEditingLawName = this._law.name;
            } else {
                this.currentlyEditingLawName = null;
                this._navService.setActiveNavItem({});
            }
        });
    }

    cancel(): void {
        if (this._law)
            this._router.navigateByUrl(`law-library/${this._law.id}`);
        else {
            this._navService.setActiveNavItem(null);
            this._router.navigateByUrl("law-library");
        }
    }

    save(): void {
        var obs: Observable<Law>;
        obs = this._law && this._law.id ? this._lawService.updateLaw(this._createLaw()) : this._lawService.createLaw(this.form.controls.name.value,
            stripFroalaWatermark(this.form.controls.content.value), this.form.controls.ORC.value);

        obs.subscribe((result) => {
            this._law = result;
            this._assignForm();
            this._navService.setActiveNavItem(null);
            this._router.navigateByUrl(`law-library/${this._law.id}`);
        });
    }

    public _createLaw(): Law {
        return {
            id: this._law.id,
            data: stripFroalaWatermark(this.form.controls.content.value),
            name: this.form.controls.name.value,
            orc: this.form.controls.ORC.value,
            uri: this._law.uri
        } as Law;
    }

    public _assignForm(): void {
        this.form.reset();

        this.form.controls.name.setValue(this._law.name);
        this.form.controls.url.setValue(`/law-library/view/${this._law.id}`);
        this.form.controls.ORC.setValue(this._law.orc);
        this.form.controls.content.setValue(this._law.data);
        this.form.controls.updatedBy.setValue(this._law.updatedBy);
        this.form.controls.updatedDate.setValue(this._law.updatedDate);
        this.form.controls.directurl.setValue(`${window.location.origin}/law-library/view/${this._law.id}`);
    }

    copyValueToClipboard(input: any): void {
        let inputEl = this._renderer.createElement('input');
        inputEl.value = input.value;

        this._renderer.appendChild(this._elementRef.nativeElement, inputEl);
        inputEl.select();
        document.execCommand('copy');
        this._renderer.removeChild(this._elementRef.nativeElement, inputEl);
    }
}
